import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../../domain/entities/ErrorEntity";
import QrBatchEntity from "../../../domain/entities/QrBatchEntity";
import SearchResultEntity from "../../../domain/entities/SearchResultEntity";
import QrRepository from "../../../domain/repositories/QrRepository";
import createQrsInBatchApiImpl from "./api/CreateQrsInBatchApiImpl";
import downloadQrBatchApiImpl from "./api/DownloadQrBatchApiImpl";
import disabledQrApiImpl from "./api/DisabledQrApiImpl";
import searchQrsBatchAiImpl from "./api/SearchQrsBatchAiImpl";
import { injectable } from "inversify";
import reDownloadQrBatchApiImpl from "./api/ReDownloadQrBatchApiImpl";

@injectable()
export default class QrRepositoryImpl implements QrRepository {
    createQrsInBatch = async (quantity: number, stablishmentId: string): Promise<Either<ErrorEntity, void>> => createQrsInBatchApiImpl(quantity, stablishmentId);
    downloadQrBatch = async (id: string): Promise<Either<ErrorEntity, void>> => downloadQrBatchApiImpl(id);
    reDownloadQrBatch = async (_: { zipToken: string, stablishmentId: string }): Promise<Either<ErrorEntity, void>> => reDownloadQrBatchApiImpl(_);
    searchQrs = async (_: { stablishmentId?: string, page: number, itemsPerPage: number }): Promise<Either<ErrorEntity, SearchResultEntity<QrBatchEntity>>> => searchQrsBatchAiImpl(_.stablishmentId ?? "");
    disableQr = async (id: string): Promise<Either<ErrorEntity, void>> => disabledQrApiImpl(id);
}